import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import UomListLayer from "../components/UomListLayer";
import UomModal from "../components/UomModal";

const UomPage = () => {
  const [uoms, setUoms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);

  const fetchUoms = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/uom`);
      const data = await res.json();
      setUoms(data);
    } catch (err) {
      console.log("Error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUoms();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Units of Measure" />

      {loading ? (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      ) : (
        <UomListLayer
          data={uoms}
          onAdd={() => setModalData({})}
          onEdit={(row) => setModalData(row)}
          onRefresh={fetchUoms}
        />
      )}

      <UomModal
        show={modalData !== null}
        onClose={() => setModalData(null)}
        data={modalData}
        onSaved={fetchUoms}
      />
    </MasterLayout>
  );
};

export default UomPage;
